import { useEffect } from 'react';

const useGoogleTagManager = () => {
  useEffect(() => {
    // Verifica se está em produção
    if (process.env.NODE_ENV !== 'production') {
      console.log(process.env.NODE_ENV, 'process.env.NODE_ENV')
      return;
    }

    const gtmId = process.env.REACT_APP_GOOGLE_TAG_MANAGER;
    
    if (!gtmId) {
      console.warn('ID do Google Tag Manager não encontrado nas variáveis de ambiente');
      return;
    }

    // Inicializa o dataLayer
    window.dataLayer = window.dataLayer || [];

    // Função para carregar o script do GTM
    const loadGTM = () => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
      
      script.addEventListener('load', () => {
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js',
          cookie_flags: 'max-age=7200;secure;samesite=none'
        });
      });

      document.head.appendChild(script);

      // Adiciona o iframe para noscript
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    };

    loadGTM();

    // Cleanup
    return () => {
      const scripts = document.querySelectorAll(`script[src*="googletagmanager.com/gtm.js"]`);
      scripts.forEach(script => script.remove());
      
      const noscripts = document.querySelectorAll('noscript iframe[src*="googletagmanager.com/ns.html"]');
      noscripts.forEach(noscript => noscript.remove());
    };
  }, []);
};

export default useGoogleTagManager;
